import React from "react";
import PricingCard from "../components/PricingCard";
const Pricing = () => {
  return (
    <div className="min-h-screen bg-white py-10 sm:py-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Açıklama Metni Değiştirilecek şu an demo */}
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            Pricing
          </h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Choose the right plan for your business
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600 mb-8">
          Distinctio et nulla eum soluta et neque labore quibusdam. Saepe et
          quasi iusto modi velit ut non voluptas in.
        </p>
        {/* Fiyatlandırma kartları */}
        <div className="flex flex-row flex-wrap gap-4">
          <PricingCard
            variant="basic"/>
          <PricingCard
            variant="colored"
            price="$59"
            title="Premium"
            description="Best option for teams & large projects."
            supportDuration="3 months"
            updatesDuration="3 months"
            teamSize="5 developers"
          />
          <PricingCard
            variant="basic"
            price="$79"
            title="Pro"
            description="Best option for teams & large projects."
            supportDuration="6 months"
            updatesDuration="6 months"
            teamSize="10 developers"
          />
        </div>
      </div>
    </div>
  );
};

export default Pricing;
